import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _typeof from "@babel/runtime/helpers/esm/typeof";

/* RelationSelector
多级联动Selector主逻辑*/
import { _$ } from './domHelper';

function tplSelect(data, def) {
  var outHtml = '';

  if ('object' === _typeof(def)) {
    outHtml = "<option value='".concat(def.val, "'>").concat(def.show, "</option>");
  }

  var select = data.select,
      arrItems = data.arrItems;

  for (var i = 0; i < arrItems.length; i++) {
    var show = arrItems[i].show;
    var value = arrItems[i].value;
    outHtml += "<option value='".concat(value, "'").concat(value == select ? 'selected' : '', ">").concat(show, "</option>");
  }

  return outHtml;
}

var RelationSelector = /*#__PURE__*/function () {
  /* 构造函数*/

  /* config:{
  selectors:[
  	//一级
  	{
  		ele:"",//绑定的元素
  		keyShow:"",//每一个item显示的值
  		keyValue:"",//每一个item
  		keySub:""//function(item){}
  	},
  	//二级
  	{
  		}
  	//...
  ],
  onChange:function(values){
  	},
  data:[],//原始数据，array
  initVal:[]
  }*/
  // constructor
  function RelationSelector() {
    var _this = this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RelationSelector);

    // def : 默认填充在最前面的默认值，如果不需要，请置空
    this.def = {
      val: '',
      show: '请选择'
    };

    if ('undefined' !== typeof config.def) {
      this.def = config.def;
    }

    var self = this;
    this.config = config;

    if (config.initVal && config.initVal.length) {
      this.config.initVal = config.initVal;
    } else {
      this.config.initVal = [];
    }

    this.currentSels = []; // 一级，二级，三级当前select数据
    // 初始化

    this.setVal(this.config.initVal);
    /* for(let i=0;i<config.selectors.length;i++){
    if(undefined === this.config.initVal[i]){
    this.config.initVal[i]='';
    }
    if(i!==0){
    let fatherItems=this.currentSels[i-1];
    let fatherItem=this.getItemByVal(i-1,fatherItems.items,this.config.initVal[i-1]);
    this.currentSels[i]={
    	items:this.getSubItems(i-1,fatherItem),
    	select:this.config.initVal[i] || ""
    };
    }else{//第一个sel
    this.currentSels[0]={
    	items:this.config.data,
    	select:this.config.initVal[i] || ""
    }
    }
    this.render(i,this.currentSels[i])
    }*/

    var def = self.def; // 绑定事件

    var _loop = function _loop(i) {
      var select = _this.config.selectors[i];

      var selectorEl = _$(select.ele);

      (function (selOrder) {
        selectorEl.onchange = function (e) {
          var val = e.target.value;
          self.currentSels[selOrder].select = val; // 是否有子选项

          if (selOrder < self.config.selectors.length - 1) {
            // 有子选项，则渲染子选项
            var subItems = self.getSubItems(selOrder, self.getItemByVal(selOrder, self.currentSels[selOrder].items, val));
            self.currentSels[selOrder + 1] = {
              items: subItems,
              select: def ? def.value : subItems[0][self.config.selectors[selOrder + 1].keyValue]
            };
            self.render(selOrder + 1, self.currentSels[selOrder + 1]); // let curItem=subItems[self.currentSels[selOrder+1].select] || null;

            var curItem = null;

            for (var _i2 = 0; _i2 < subItems.length; _i2++) {
              if (subItems[_i2][self.config.selectors[selOrder + 1].keyValue] == self.currentSels[selOrder + 1].select) {
                curItem = subItems[_i2];
                break;
              }
            }

            var sItems;

            for (var j = selOrder + 2; j < self.config.selectors.length; j++) {
              sItems = self.getSubItems(j, curItem);
              self.currentSels[j] = {
                items: sItems,
                select: def ? def.value : sItems[0][self.config.selectors[j].keyValue]
              };
              self.render(j, self.currentSels[j]);
              curItem = sItems[self.currentSels[j].select] || null;
            }
          } // 触发change事件


          if (self.config.onChange && 'function' === typeof self.config.onChange) {
            self.config.onChange(self.currentSels.map(function (sel) {
              return sel.select;
            }), selOrder);
          }
        };
      })(i);
    };

    for (var i = 0; i < this.config.selectors.length; i++) {
      _loop(i);
    } // 初始化


    setTimeout(function () {
      var arrVal = [];

      for (var _i = 0; _i < self.config.selectors.length; _i++) {
        arrVal.push(_$(self.config.selectors[_i].ele).value);
      }

      if (self.config.onChange && 'function' === typeof self.config.onChange) {
        self.config.onChange(arrVal, 0);
      }
    }, 100);
  }

  _createClass(RelationSelector, [{
    key: "render",
    value: function render(selOrder, sel) {
      var def = this.def;
      var cfg = this.config.selectors[selOrder];

      var selectorEl = _$(cfg.ele);

      var keyValue = cfg.keyValue;
      var keyShow = cfg.keyShow;
      var newItem = {};
      /* sel.items.forEach(function(item){
      newItem[item[keyValue]]=item[keyShow];
      })*/

      var arrItems = [];

      for (var i = 0; i < sel.items.length; i++) {
        var item = sel.items[i];
        newItem[item[keyValue]] = item[keyShow];
        arrItems.push({
          show: item[keyShow],
          value: item[keyValue]
        });
      }

      var selectHtml = tplSelect({
        items: newItem,
        select: sel.select,
        arrItems: arrItems
      }, def);
      selectorEl.innerHTML = selectHtml;
    }
    /*	trigger(selOrder,item){
    }*/

  }, {
    key: "getSubItems",
    value: function getSubItems(selOrder, item) {
      if (!item) {
        return []; // 无
      }

      var cfg = this.config.selectors[selOrder];
      var sub = cfg.keySub;

      if ('string' === typeof sub) {
        return item[sub] || [];
      }

      if ('function' === typeof sub) {
        return sub(item, selOrder) || [];
      }
    }
  }, {
    key: "getItemByVal",
    value: function getItemByVal(selOrder, items, val) {
      if (val === '') {
        return null;
      }

      var keyValue = this.config.selectors[selOrder].keyValue;

      for (var i = 0; i < items.length; i++) {
        if (val == items[i][keyValue]) {
          return items[i];
        }
      }
    }
  }, {
    key: "getShowByVal",
    value: function getShowByVal(arrVal) {
      var showArr = [];
      var items = this.config.data;

      for (var i = 0; i < arrVal.length; i++) {
        var keyShow = this.config.selectors[i].keyShow;
        var item = this.getItemByVal(i, items, arrVal[i]);

        if (!item) {
          showArr.push('');
        } else {
          showArr.push(item[keyShow]);
        }

        items = this.getSubItems(i, item);
      }

      return showArr;
    }
  }, {
    key: "setVal",
    value: function setVal(arrVal) {
      // alert("请完善setVal方法");
      // 初始化
      var config = this.config;

      for (var i = 0; i < config.selectors.length; i++) {
        if (undefined === arrVal[i]) {
          arrVal[i] = '';
        }

        if (i !== 0) {
          var fatherItems = this.currentSels[i - 1];
          var fatherItem = this.getItemByVal(i - 1, fatherItems.items, arrVal[i - 1]);
          this.currentSels[i] = {
            items: this.getSubItems(i - 1, fatherItem),
            select: arrVal[i] || ''
          };
        } else {
          // 第一个sel
          this.currentSels[0] = {
            items: this.config.data,
            select: arrVal[i] || ''
          };
        }

        this.render(i, this.currentSels[i]);
      }
    }
  }]);

  return RelationSelector;
}();

export default RelationSelector;